import { Props } from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";

export type InfiniteScrollConfigType<T> = Omit<Props, "children" | "loader"> & {
  pageNumber: number;
  tableData: T[];
  customLoader?: JSX.Element;
};

export const generateSkeletonLoaderForTable = (
  numberColumns: number,
  skeletonClassName?: string
): JSX.Element => (
  <>
    {Array.from({ length: numberColumns }).map((v, i) => (
      <td key={i} style={{ padding: ".1rem" }}>
        <Skeleton className={skeletonClassName} />
      </td>
    ))}
  </>
);
